import { ThemeEvents } from '@theme/events';

export function renderSizeUnit(host, mode) {
  if (host.dataset.supported !== 'true' || !['metric', 'imperial'].includes(mode)) return false;
  if (!['GB', 'US'].includes(host.dataset.country) || (host.dataset.country === 'US' && mode !== 'imperial')) return false;
  const unit = mode === 'metric' ? 'cm' : 'in';
  const title = host.querySelector('[data-size-title]');
  if (!title) return false;
  title.textContent = `${title.dataset.sizeTitle} (${unit}):`;
  host.querySelectorAll('[data-size-metric]').forEach(label => {
    label.textContent = mode === 'metric' ? label.dataset.sizeMetric : label.dataset.sizeImperial;
    label.closest('label')?.querySelector('input')?.setAttribute('aria-label', `${label.textContent} ${unit}`);
  });
  host.querySelectorAll('[data-size-unit]').forEach(button => {
    button.setAttribute('aria-pressed', String(button.dataset.sizeUnit === mode));
  });
  host.dataset.mode = mode;
  host.dispatchEvent(new host.ownerDocument.defaultView.CustomEvent('artesta:size-unit-change', { bubbles: true }));
  return true;
}

if (globalThis.customElements && !customElements.get('artesta-size-units')) {
  customElements.define('artesta-size-units', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.supported !== 'true' || !['GB', 'US'].includes(this.dataset.country)) return;
      let mode = 'imperial';
      if (this.dataset.country === 'GB') {
        try { if (sessionStorage.getItem('artesta:GB:size-unit') === 'metric') mode = 'metric'; } catch {}
      }
      this.onClick = event => {
        const button = event.target.closest('[data-size-unit]');
        if (!button || !this.contains(button) || this.dataset.country !== 'GB') return;
        event.preventDefault();
        if (renderSizeUnit(this, button.dataset.sizeUnit)) {
          mode = button.dataset.sizeUnit;
          try { sessionStorage.setItem('artesta:GB:size-unit', mode); } catch {}
        }
      };
      this.scope = this.closest('[id*="ProductInformation-"], .product-information, .shopify-section')
        || this.closest('variant-picker');
      this.onVariant = () => queueMicrotask(() => { if (this.isConnected) renderSizeUnit(this, mode); });
      this.scope?.addEventListener(ThemeEvents.variantUpdate, this.onVariant);
      this.addEventListener('click', this.onClick);
      renderSizeUnit(this, mode);
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.scope?.removeEventListener(ThemeEvents.variantUpdate, this.onVariant);
    }
  });
}
